import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=bcd26e5a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcd26e5a')) {
      api.createRecord('bcd26e5a', component.options)
    } else {
      api.reload('bcd26e5a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=bcd26e5a&", function () {
      api.rerender('bcd26e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IBCuvEpl5HYn/JS/offershelp.vue"
export default component.exports